import getEnvValue from '@joybird/joystagram-components/dist/esm/getEnvValue';

const isUjetChatEnabled = () => {
  const UJET_ENABLED = getEnvValue('REACT_APP_UJET_ENABLED');
  const CHAT_WIDGET_VARIANT = getEnvValue('REACT_APP_CHAT_WIDGET');

  return UJET_ENABLED === 'yes' && CHAT_WIDGET_VARIANT === 'ujet';
};

export default isUjetChatEnabled;
